module.exports = __webpack_public_path__ + "img/ava.0cd3304319dc1ecfdf08c15a97457833.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ava.png
// module id = 67
// module chunks = 1